import { Promise } from 'es6-promise';

import { SU } from '../../constants';
import FSA from '../FSA';
import suRequest from './requestFactory';
import { fetchContainer } from './System';
import objectAssign = require('object-assign');

interface ISystemJobs {
    nodeId?: string
}

interface IParams {
    container: any,
    start: Date,
    end: Date,
    customerId: string,
}

function fetchJobs(requesterId: string, params: IParams) {
    const { container, customerId, start, end } = params;

    const query = {};

    return suRequest.get(`patch/${customerId}/container/${container.id}/jobs?start=${params.start.getTime()}&end=${params.end.getTime()}`, query).then((jobs) => {
        let containerWithJobs = objectAssign({}, container, { jobs: jobs });
        return containerWithJobs;
    });
}

function listJobs(requesterId: string, query, params: IParams): Function {
    return dispatch => {
        dispatch(new FSA(SU.FETCH_JOBS_REQUEST).addMeta({ requesterId }).data);
        return fetchContainer(requesterId, query).then(containers => {
            let promises = containers.map(container => {
                params.container = container;
                return fetchJobs(requesterId, params);
            });

            Promise.all(promises).then(result => {
                return dispatch(new FSA(SU.FETCH_JOBS_SUCCESS).addPayload(result).addMeta({ requesterId }).data);

            }).catch(err => {
                dispatch(new FSA(SU.FETCH_JOBS_FAILURE).addError(err).addMeta({ requesterId }).data);
                throw err;
            });
        }).catch(err => {
            dispatch(new FSA(SU.FETCH_JOBS_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}

export {
    ISystemJobs,
    fetchJobs,
    listJobs,
};


// WEBPACK FOOTER //
// ./src/actions/su/Job.ts